import { render, staticRenderFns } from "./r-swamp-page.vue?vue&type=template&id=2b5aad48"
import script from "./r-swamp-page.vue?vue&type=script&lang=js"
export * from "./r-swamp-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b5aad48')) {
      api.createRecord('2b5aad48', component.options)
    } else {
      api.reload('2b5aad48', component.options)
    }
    module.hot.accept("./r-swamp-page.vue?vue&type=template&id=2b5aad48", function () {
      api.rerender('2b5aad48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/world-biomes/swamp/r-swamp-page.vue"
export default component.exports